import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@skin-seoul/design-system';
import { CLASSNAME, detectBrowserLanguage, getLanguageCookie, setLanguageCookie } from '@skin-seoul/service';

import { useMemo } from 'react';
import { GOOGLE_TRANSLATE_LANGUAGE_OPTIONS, type LanguageOption } from './constants';

type TranslateLanguageSelectProps = {
  value?: string;
  onChange?: (language: string) => void;
  applyImmediately?: boolean;
};

export const TranslateLanguageSelect = ({ value, onChange, applyImmediately = true }: TranslateLanguageSelectProps) => {
  const items = useMemo<LanguageOption[]>(
    () => GOOGLE_TRANSLATE_LANGUAGE_OPTIONS.map((o: LanguageOption) => ({ value: o.value, label: o.label })),
    [],
  );

  const browserLanguage = useMemo(() => detectBrowserLanguage(), []);

  const selected = value ?? getLanguageCookie() ?? browserLanguage;

  return (
    <div className="flex flex-col gap-1.5">
      <label className={`${CLASSNAME.NOT_TRANSLATE} text-paragraph-small text-neutral-900`}>Language Setting</label>
      <Select
        value={selected}
        onValueChange={(lang) => {
          onChange?.(lang);
          if (applyImmediately) {
            setLanguageCookie(lang);
            if (typeof window !== 'undefined') {
              window.dispatchEvent(new CustomEvent('ss:user-language-change', { detail: lang }));
            }
          }
        }}
      >
        <SelectTrigger className="h-10 border border-neutral-900 hover:border-neutral-300">
          <SelectValue className={`${CLASSNAME.NOT_TRANSLATE} text-paragraph-small text-neutral-900`} />
        </SelectTrigger>
        <SelectContent className="max-h-[30dvh] shadow-[0px_0px_10px_0px_rgba(0,0,0,0.1)]">
          {items.map((lang: LanguageOption) => (
            <SelectItem
              key={lang.value}
              value={lang.value}
              className={`py-3 px-2 ${CLASSNAME.NOT_TRANSLATE} data-[state=checked]:bg-neutral-100/60`}
            >
              {lang.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default TranslateLanguageSelect;
